import { render, staticRenderFns } from "./ReviewPlant.vue?vue&type=template&id=c215ef14&scoped=true&"
import script from "./ReviewPlant.vue?vue&type=script&lang=js&"
export * from "./ReviewPlant.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlant.vue?vue&type=style&index=0&id=c215ef14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c215ef14",
  null
  
)

export default component.exports